<template>
  <div class="container">
    <div class="dashboard columns">
      <div class="column column-55">
        <div class="column-body">
          <Projects />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import fake from "../../fake";

import Projects from "../../components/Dashboard/Projects";

export default {
  data() {
    return {
      data: fake
    };
  },
  computed: {
    ...mapState(['selectedProject'])
  },
  components: {
    Projects,
  }
};
</script>

<style lang="scss">
.columns {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.column {
  padding: 0 15px 15px;
  border-radius: 10px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-20 {
    width: 400px;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  }

  &-55 {
    width: 100%;
  }
}
</style>
